<template>
    <router-link v-bind:to="to">
        <div class="page-link">
            <div class="page-info"> 
                <span class="page-title"> {{ title }} </span>
                <div class="page-date"> {{ date }} </div>
                <div class="page-desc"> {{ desc }} </div>
            </div>

            <div class="page-thumb" :style="'display: ' + ((preview) ? 'block' : 'none')">
                <img v-bind:src="preview"/>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
  name: 'PostPreview',
  props: ["to", "title", "date", "desc", "preview"],
  mounted: () => {
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.page-link {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  color: black;
  background-color: white;
  box-shadow: 5px 5px 10px 2px gainsboro;
  transition: background-color 0.2s;
  border-radius: 20px;
  margin: 15px 0px;
  max-width: 800px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.page-link:hover {
  background-color: #ebebeb;
  border-top: 1px solid #ebebeb;
  cursor: pointer;
}

.page-title {
  font-size: 17pt;
  font-weight: 100;
}

.page-date {
  font-size: 12pt;
  color: grey;
}

.page-info {
    width: 100%;
}

.page-link:hover .page-thumb {
    width: 200px;
    height: 110px;
}

.page-link:hover .page-thumb > img {
    height: 100%;
    width: 100%;
}

.page-thumb {
    display: flex;
    justify-content: flex-end;
    align-content: flex-end;
    transition: width 0.5s, height 0.5s;
    height: 80px;
    width: 0px;
}

.page-thumb > img {
    object-fit: contain;
    max-height: 110px;
    height: 0px;
    width: 0px;
}

</style>
